export default __webpack_public_path__ + "static/media/Workplace_Wordmark_Gray.7462a7e9.png";